import React, { useEffect, useState } from 'react';
import Modal from 'react-modal/lib/components/Modal';
import Button from "./button"
import Icon from "./icon"
Modal.setAppElement("#root")
const Modals = ({ modalTitle, display, modalContent, hanldeModalClose }) => {

    const [isOpenModal, setisOpenModal] = useState();

    useEffect(() => {
        setisOpenModal(display)
    }, [display]);

    return (
        <>
            <Modal isOpen={isOpenModal} style={{
                overlay: {
                    backgroundColor: 'rgba(28, 29, 28, 0.8)',
                },
                content: {
                    color: 'lightsteelblue',
                    padding: "0px"
                }
            }} >
                <div className='sticky top-0 bg-slate-200'>
                    <div className='container flex justify-between p-3 items-center mb-2'>
                        <h2 className="text-kombuGreen text-md font-semibold lg:text-xl">{modalTitle}</h2>
                        <Button event={hanldeModalClose} name={<Icon iconName={"FaWindowClose"} styles={"cursor-pointer text-ashGray text-2xl hover:text-dangerColor"} />}></Button>
                    </div>
                </div>
                {modalContent}
            </Modal>
        </>);
}

export default Modals;